<template>
  <div>
    <v-card class="cardWrap">
      <CardTitle title="プラン用マスタ管理" />
      <v-tabs
          background-color="white accent-4"
          color="black"
        >
        <v-tab @click="seen = 'Course'">コース</v-tab>
        <v-tab @click="seen = 'Tax'">税関連</v-tab>
        <v-tab @click="seen = 'CancelPolicie'">キャンセルポリシー</v-tab>
        <v-tab @click="seen = 'Benefit'">特典</v-tab>
      </v-tabs>
      <keep-alive>
        <component :is="seen" />
      </keep-alive>
    </v-card>
  </div>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import Course from './planmasterpage/Course';
import Benefit from './planmasterpage/Benefit';
import Tax from './planmasterpage/Tax';
import CancelPolicie from './planmasterpage/CancelPolicie';

export default {
    components: {
        CardTitle,
        Course,
        Benefit,
        Tax,
        CancelPolicie
    },
    data () {
        return {
            seen: 'Course',
            vue_id: 'SCR0030'
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize: async function () {
        }
    }
};
</script>

<style>

</style>
